import { render, staticRenderFns } from "./LandingPlaces.vue?vue&type=template&id=11aeb400"
import script from "./LandingPlaces.vue?vue&type=script&lang=js"
export * from "./LandingPlaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports